import React from 'react';
import Link from 'gatsby-link';
import MediaQueries from 'react-responsive';

import Button from '@marvelapp/marvel-ui/button';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Spacing from '@marvelapp/marvel-ui/spacing';
import LogoRow from '@marvelapp/marvel-ui/logo-row';

import MediaFeature from 'marketing-website/components/modules/Media/MediaFeature';
import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';

import assets from 'marketing-website/configs/pages/homepage/assets';
import logos from 'marketing-website/configs/pages/homepage/caseStudyLogos.js';

export default function CaseStudies() {
  const Mobile = props => <MediaQueries {...props} maxWidth={770} />;

  return (
    <Spacing sizeM="xl" position="topBottom" type="margin">
      <MediaFeature
        borderRadius="none"
        src={assets.caseStudies.src}
        alt="The world's most innovative companies use Marvel everyday to scale design"
        hasShadow={false}
        backgroundColor="white"
      >
        <HeadingBlock
          alignContent="center"
          alignM="left"
          headingSize="xxl"
          paragraphMaxWidth={400}
          headingMaxWidth={346}
          title="The world's most innovative companies use Marvel everyday to scale design"
          copy={
            <span>
              The digital products, from around the world, that you know and
              love have been built with Marvel.
              <br />
              <br />
              Our customers range from Fortune 100 companies, to startups and
              schools - all using our online design platform to ideate fast,
              collaborate and optimise prototypes before development.
            </span>
          }
        >
          <div>
            <Link to="/customer-stories/">
              <Button shape="rounded" kind="ghost" size="large">
                Read Customer Stories
              </Button>
            </Link>
          </div>
          <MaxWidth value={400}>
            <Spacing size="l" position="topBottom" type="margin">
              <Mobile>
                <LogoRow logos={logos} align="left" />
              </Mobile>
            </Spacing>
          </MaxWidth>
        </HeadingBlock>
      </MediaFeature>
    </Spacing>
  );
}



// WEBPACK FOOTER //
// ./src/components/modules/CaseStudies/index.js